import type { App } from 'vue'

import { createHead } from '@unhead/vue'

import { vueApi, useApi } from './api'
import initPinia from './pinia'

import { registerLayouts } from './layouts'

import router from '../router'

import { initMetrika } from '@/plugins/metrika'

let env = import.meta.env.DEV ? 'development' : 'production'
if (import.meta.env.MODE) env = import.meta.env.MODE

export function registerPlugins(app: App) {
  app
    .use(vueApi, {
      env,
      config: {
        baseURL:
          env === 'development'
            ? '/api/v1'
            : import.meta.env.VITE_REST_ENDPOINT,
      },
    })
    .use(router)
    .use(initPinia(useApi))
    .use(createHead())

  registerLayouts(app)
  initMetrika(app, router)
}
